import { createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
  name: "myDocument",
  initialState: {
    isLoading: false,
    currentOvertime: {},
    myDocumentList: [],
    currentMyDocument: {},
    collectTime: [],
    companyRegulations: [],
    myShift: {},
    employeeSwapShift: {},
    employeeSwap: {},
    attendanceSettingShifts: [],
    currentWorking: {},
    workInLocation:[]

  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setMyDocumentList(state, action) {
      state.myDocumentList = action.payload;
    },
    setCurrentMyDocument(state, action) {
      state.currentMyDocument = action.payload;
    },
    setCollectTime(state, action) {
      state.collectTime = action.payload;
    },
    setCurrentOvertime(state, action) {
      state.currentOvertime = action.payload;
    },
    setCurrentWorking(state, action) {
      state.currentWorking = action.payload;
    },
    setCompanyRegulations(state, action) {
      state.companyRegulations = action.payload;
    },
    setMyShift(state, action) {
      state.myShift = action.payload;
    },
    setEmployeeSwapShift(state, action) {
      state.employeeSwapShift = action.payload;
    },

    setEmployeeSwap(state, action) {
      state.employeeSwap = action.payload;
    },
    setAttendanceSettingShifts(state, action) {
      state.attendanceSettingShifts = action.payload;
    },
    setWorkInLocation(state, action) {
      state.workInLocation = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setMyDocumentList,
  setCurrentMyDocument,
  setCollectTime,
  setCompanyRegulations,
  setMyShift,
  setEmployeeSwapShift,
  setEmployeeSwap,
  setAttendanceSettingShifts,
  setCurrentOvertime,
  setCurrentWorking,
  setWorkInLocation
} = optionsSlice.actions;
export default optionsSlice.reducer;
